import PageHeader from "components/layout/page-header";
import PageWrapper from "components/layout/page-wrapper";
import { FC } from "react";
import { Link } from "react-location";
import { classNames } from "utils";
import useUrlState from "utils/use-url-state";
import RevenueReportsTabs from "./tabs/revenue";
import PaymentsReportsTabs from "./tabs/payments";
import ClaimsReportsTabs from "./tabs/claims";
import { useTitle } from "react-use";
import { usePage } from "hooks/usePage";
import { useTranslation } from "react-i18next";

type Props = {};

const ReportsPage: FC<Props> = (props) => {
    const { t } = useTranslation();
    usePage(`Kava | ${t("reports_page.title")}`);
    const [orderStatus] = useUrlState("orderStatus");

    const tabs = [
        { name: t("reports_page.tabs.payments_report"), href: "payment" },
        { name: t("reports_page.tabs.claims_report"), href: "claims" },
    ];

    return (
        <PageWrapper>
            <PageHeader title={t("reports_page.header")} />
            <div className="block">
                <div className="border-b border-gray-200 ">
                    <nav
                        className="-mb-px flex space-x-8 items-center"
                        aria-label="Tabs">
                        <Link
                            search={(old) => ({
                                ...old,
                                orderStatus: undefined,
                            })}
                            className={classNames(
                                !orderStatus
                                    ? "border-green-500 text-green-600"
                                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-200",
                                "whitespace-nowrap flex py-4 px-1 border-b-2 font-medium text-sm",
                            )}
                            aria-current={!orderStatus ? "page" : undefined}>
                            {t("reports_page.tabs.revenue_report")}
                        </Link>
                        {tabs.map((_orderStatus) => (
                            <Link
                                key={_orderStatus.name}
                                search={(old) => ({
                                    ...old,
                                    orderStatus: _orderStatus.href,
                                })}
                                className={classNames(
                                    orderStatus === _orderStatus.href
                                        ? "border-green-500 text-green-600"
                                        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-200",
                                    "whitespace-nowrap flex py-4 px-1 border-b-2 font-medium text-sm",
                                )}
                                aria-current={
                                    orderStatus === _orderStatus.href
                                        ? "page"
                                        : undefined
                                }>
                                {_orderStatus.name}
                            </Link>
                        ))}
                        {/* <div className="h-6 w-px bg-gray-300" /> */}
                    </nav>
                </div>
            </div>
            <div className="flex flex-1 overflow-y-auto">
                <div className="flex-1 mx-auto min-w-0   sm:py-6 overflow-hidden overflow-y-auto light flex">
                    {!orderStatus && <RevenueReportsTabs />}
                    {orderStatus === "payment" && <PaymentsReportsTabs />}
                    {orderStatus === "claims" && <ClaimsReportsTabs />}
                </div>
            </div>
        </PageWrapper>
    );
};

export default ReportsPage;
